/**
 * Partenaires 
 */
// @ts-ignore
const partnersSwiper: Swiper = new Swiper("#partners-swiper", {
    spaceBetween: 10,
    centerInsuficientSlides: true,
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        '0': {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        '768': {
            slidesPerView: 3,
            spaceBetween: 20,
        }
    }
});
